import * as parent from '../variables';
import { IS_ADMIN } from '../../constants/validation';

export const colors = {
  ...parent.colors,
  ...(IS_ADMIN
    ? {
      FOOTER_TEXT: '#b0b0b0',
      INPUT_BORDER: '#8A8B8C',
      TERNARY_BORDER: '#8A8B8C',
      LINK_COLOR: '#78c81a',
      LOGIN_BACKGROUND: '#455560',
      SELECTED_MENU_BG: '#000',
      PRIMARY_MAIN: '#f0f2f2',
      HEADER_COUNT_TEXT: '#455560',
      MENU_BACKGROUND: '#fff',
      MENU_BORDER_COLOR: '#78c81a',
      CHIP_BG: '#fff',
      RESELLER_SELECT_COLOR_FIRST: '#000',
      RESELLER_SELECT_COLOR_LAST: '#000',
      NON_SELCTED_SVG_COLOR: '#fff',
      PRIMARY_CONTRAST: '#455560',
      PRIMARY_BORDER: '#ccc',
      GREY: '#999',
      DAILY_LOG_GRAPH_BORDER: '#919191',
      SELECTED_MENU_TITLE: '#fff',
      MENU_TITLE: '#fff',
      USER_NAME_COLOR: '#fff',
      NORMAL_LINK: '#47545e',
      MODAL_TEXT: '#797979',
      MODAL_HEADING: '#575757',
      LOGOUT_BUTTON: '#78c81a',
      LIST_TEXT: '#455560',
      HEADER_LIST_TEXT: '#455560',
      LIGHT_BORDER: '#2d2b2b',
      MENU_BACKGROUND: '#2c2c2c',
      SECONDARY_CONTRAST: '#fff',
      WHITE: '#fff',
      INPUT_BACKGROUND: '#ffffff',
      RED: '#ff0000',
      BLACK: '#000',
      BACKGROUND: '#fff',
      BLACK_THREE: '#373737',
      RED_TWO: '#d34343',
      GREEN: '#32cd32',
      GREEN_TWO: '#97AE46',
      GREY_ELEVEN: '#777070',
      GREY_TWELVE: '#c3c3c3',
      BLACK_FOUR: '#333333',
      GRAPH_BLACK: '#212121',
      CHART_BLUE: '#00e2ff',
      WARNING: '#ffff00',
      GREY_DATA: '#696969',
      HEADER_COLOR: '#2c2c2c',
      HEADER_COLOR2: '#2c2c2c17',
      DOCUMENT_LINE: '#2C3249',
      DISABLED_COLOR: '#889ccc',
      RADIO_BACKGROUND: '#f0f2f2',
      FORM_COLOR: '#191e22',
      SUGGESTED_COLOR: '#00b7a0',
      BODY_BACKGROUND: '#f0f2f2',
      CHECKBOX_TICK: '#78c81a',
      PAGINATION_ALTERNATE_BACKGROUND: '#f8f8f8',
      PAGINATION_COLOR: '#fff',
      SELECTED_AREA: 'rgba(32, 177, 232, 0.6)',
      MAP: {
        LIGHT_BLACK: '#424D66',
        LIGHTER_BLACK: '#424D66',
        BLACK: '#424D66',
        GREY: '#d1d1d1',
        LIGHT_GREY: '#d1d1d1',
        LIGHTER_GREY: '#d1d1d1',
        WATER: '#2B364F',
        ROAD: '#37425C',
      },
      LOGIN_BUTTON: '#78c81a',
      BACKGROUND_MENU: '#455560',
      TITLE_COLOR: '#191e22',
      LOGIN_INPUTBG: '#fff',
      INPUT_COLOR: '#455560',
      INPUT_FOCUS: '#78c81a',
      TABLE_ROW_COLOR: '#39434c',
      SORT_ICON: '#78c81a',
      LOGOUT_BUTTON: '#78c81a',
      PAGINATION_HEADER: '#455560',
      HEADER_TEXT: '#fff',
      PAGINATION_BORDER: '#f0f2f2',
      RESET_BUTTON: '#47545e',
      ACTION_BORDER: '#455560',
      PRIMARY_BUTTON_TEXT: '#fff',
      FORM_INPUT_BG: '#f0f2f2',
      FORM_INPUT_BG_LOGIN: '#2c2c2c',
      INPUT_COLOR_LOGIN: '#000',
      MULTISELECT_BACKGROUND: '#455560',
      MULTISELECT_LABEL: '#f0f2f2',
      FORM_BACKGROUND: '#fff',
      RESET_BACKGROUND: '#455560',
      RESET_COLOR: '#ffffff',
      CHECKBOX_BORDER: '#d1d3d6',
      SELECT_ACTIONS: '#444',
      SECONDARY_BORDER: '#d0d4d7',
      TAB_HIGHLIGHT: '#78c81a',
      TAB_BOTTOM_BORDER: '#9cc663',
      TAB_HIGHLIGHT_BACKGROUND: '#fff',
      ACCORDION_BACKGROUND: '#fff',
      USER_LOGO_BACKGROUND: '#455560',
      USER_LOGO_COLOR: '#ffffff',
      POLICIES_BACKGROUND: '#fff',
      TOOLTIP_COLOR: '#000',
      ALERT_COLOR: '#ce1e51',
      ALERT_BACKGROUND: '#2a3135',
    }
    : {}),
  ...(IS_ADMIN
    ? {}
    : {
      PRIMARY_MAIN: '#fff',
      BACKGROUND: '#efefef',
      HEADER_COUNT_TEXT: '#373737',
      PRIMARY_CONTRAST: '#373737',
      PUBLIC_HEADERCOLOR: '#2c2c2c',
      LANGUAGE_SWITCH: '#78c81a',
      HEADER_TEXT: '#f4f6f9',
      BODY_BACKGROUND: '#fff',
      MODAL_BORDER: '#d9d9d9',
      MODAL_LINK: '#78c81a',
      LINK_COLOR: '#78c81a',
      HEADER_COLOR: '#78c81a',
      CHECKBOX_TICK: '#000',
      ACTIVE_ROW: 'rgba(254, 236, 222, 0.7)',
      PAGINATION_COLOR: '#000',
      SELECTED_AREA: 'rgba(120, 200, 26, 0.3)',
      BACKGROUND_MENU: '#f4f6f9',
      INPUT_BORDER: '#ccc',
      USER_LOGO_BACKGROUND: '#fff',
      USER_LOGO_COLOR: '#78c81a',
    }),
  RANGE_PICKER: {
    CELL_BG: '#dfdfdf',
    CELL_HOVER_BG: '#bbbbbb',
  },
  PAGINATION_BACKGROUND: '#fff',
  MODAL_BACKGROUND: '#fff',
  SECONDARY_MAIN: '#78c81a',
};
export const fonts = ['Yanone Kaffeesatz', 'tahoma'].join(',');
export const secondaryFont = 'Permanent Marker';
export const tableFont = 'tahoma';
export const headerFont = '24px';
export const subTitle = '22px';
export const titleLabel = '24px';
export const formlabelFont = '24px';
export const buttonFont = '23px';
export const inputFont = '16px';
export const checkboxFont = '17px';
export const addbuttonFont = '23px';
export const companyDataFont = '28px';
export const iftaReport = '16px';
export const inspectionInput = '24px';
export const inspectionresolution = '20px';
